angular.extend(window.config, {
  appId: 'landing',
  appPath: '/',
  appName: 'Landing',
});
